import React from "react";
import { Modal, Image } from "react-bootstrap";
import { checkEmptyOrNull, hasRole } from "../Utils";
import Loader from "./Loader";
import moment from "moment";
import userIcon from "../../assets/images/user_icon.png";

const MemberDetailsModal = ({ show, onHide, detailData = {}, loading = false }) => {
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="modal_title1"
        >
          Member Details{" "}
          <Image
            width={80}
            height={80}
            src={detailData?.profile_image || userIcon}
            onError={(e) => {
              e.target.src = userIcon;
            }}
            rounded
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Loader loading={loading} />
        ) : (
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member ID</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.member_id)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Email</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.email)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Mobile Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.mobile_number)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Whatsapp Mobile Number
                  </label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.whatsapp_mobile_number)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Company name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.company_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Address</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.address)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Bio Description</label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.bio_description)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Our Products and Services
                  </label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.our_products_and_services)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Birth</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.dob)}
                  </span>
                </div>
              </div>

              {hasRole([1]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Country</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.country_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">State</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.state_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">City</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.city_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 8]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Region</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.region_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 8, 2]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Chapter</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.chapter_name)}
                    </span>
                  </div>
                </div>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">User Role</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.user_role_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Category</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.category_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Sub Category</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.sub_category_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member Crowns</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.crowns_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Payment Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.payment_date)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Payment Attachment</label>
                  <div className="mt-1">
                    {detailData?.payment_attachment ? (
                      detailData.payment_attachment.toLowerCase().endsWith(".pdf") ||
                      detailData.payment_attachment.toLowerCase().includes(".pdf") ? (
                        <a
                          href={detailData.payment_attachment}
                          target="_blank"
                          rel="noreferrer"
                          className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                          style={{ fontSize: "12px", padding: "6px 10px" }}
                        >
                          <i className="bx bxs-file-pdf font-size-14"></i> Open PDF in new tab
                        </a>
                      ) : (
                        <a
                          href={detailData.payment_attachment}
                          target="_blank"
                          rel="noreferrer"
                          title="View image"
                        >
                          <img
                            src={detailData.payment_attachment}
                            alt="Payment Attachment"
                            style={{
                              maxHeight: "80px",
                              maxWidth: "140px",
                              objectFit: "contain",
                              borderRadius: "6px",
                              border: "1px solid #cbd5e1",
                            }}
                          />
                        </a>
                      )
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Joining</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.date_of_joining)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Due Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_due_date)}
                  </span>
                </div>
              </div>

              {/* <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Attachment</label>
                  <div className="mt-1">
                    {detailData?.membership_attachment ? (
                      detailData.membership_attachment.toLowerCase().endsWith(".pdf") ||
                      detailData.membership_attachment.toLowerCase().includes(".pdf") ? (
                        <a
                          href={detailData.membership_attachment}
                          target="_blank"
                          rel="noreferrer"
                          className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                          style={{ fontSize: "12px", padding: "6px 10px" }}
                        >
                          <i className="bx bxs-file-pdf font-size-14"></i> Open PDF in new tab
                        </a>
                      ) : (
                        <a
                          href={detailData.membership_attachment}
                          target="_blank"
                          rel="noreferrer"
                          title="View image"
                        >
                          <img
                            src={detailData.membership_attachment}
                            alt="Membership Attachment"
                            style={{
                              maxHeight: "80px",
                              maxWidth: "140px",
                              objectFit: "contain",
                              borderRadius: "6px",
                              border: "1px solid #cbd5e1",
                            }}
                          />
                        </a>
                      )
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              </div> */}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Blood Group</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.blood_group_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">GST Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.gst)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Pan Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.pan)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Website</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.website)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Instagram Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.instagram_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Linkedin Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.linkedin_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Twitter Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.twitter_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Youtube Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.youtube_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Referred By</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.referred_by_text)}
                  </span>
                </div>
              </div>

              {detailData.referred_by === 3 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Name</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_name)}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Mobile</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_mobile)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              {detailData.referred_by === 2 && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Referrer Name</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.ref_member_name)} -{" "}
                      {checkEmptyOrNull(detailData.ref_member_region)} -{" "}
                      {checkEmptyOrNull(detailData.ref_member_chapter)}
                    </span>
                  </div>
                </div>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Status</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_status_text)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary ibutton"
          data-bs-dismiss="modal"
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MemberDetailsModal;
